import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IFilterOutput } from '../filter.interface';
import { CommonUtility } from '../../../utility/common.utility';
import { SharedCommonUtility } from '../../../../../shared/utils/common.utility';

@Component({
  selector: 'app-multivalue-input',
  templateUrl: './multivalue-input.component.html',
  standalone: false,
  styleUrls: ['./multivalue-input.component.scss'],
})
export class MultivalueInputComponent implements OnInit, OnChanges, OnDestroy {
  protected readonly SharedCommonUtility: typeof SharedCommonUtility = SharedCommonUtility;
  private subscriptions: Subscription;
  @Input() public label: string;
  @Input() public description?: string;
  @Input() public field: string;
  @Input() public placeholder: string = '';
  @Input() public set values(val: string[]) {
    this._values = val || [];
  }
  public get values(): string[] {
    return this._values;
  }
  private _values: string[] = [];
  @Output() public valueChange: EventEmitter<IFilterOutput<string[]>> = new EventEmitter<IFilterOutput<string[]>>();
  public output: IFilterOutput<string[]>;
  public domID: string;
  public innerForm: UntypedFormGroup;
  private isInternalChipUpdate: boolean = false;

  public get innerInputName(): string {
    return `${this.field}_input`;
  }

  public constructor(private formBuilder: UntypedFormBuilder) {
    this.domID = `${CommonUtility.createUniqueDOMId()}`;
    this.subscriptions = new Subscription();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['values'] && !changes['values'].firstChange) {
      const newValues = changes['values'].currentValue;

      if (this.isInternalChipUpdate) {
        this.isInternalChipUpdate = false;
        return;
      }

      if ((!newValues || newValues.length === 0) && this.innerForm) {
        this.innerForm.get(this.innerInputName)?.setValue('', { emitEvent: false });
      }
    }
  }

  public ngOnInit(): void {
    this.innerForm = this.formBuilder.group({
      [this.innerInputName]: this.formBuilder.control(''),
    });
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public addValueOnEnter(): void {
    const inputValue: string = this.innerForm.get(this.innerInputName)?.value;
    const trimmedValue: string = inputValue?.trim();

    if (!trimmedValue || this.values.includes(trimmedValue)) {
      return;
    }

    this.isInternalChipUpdate = true;
    this.valueChange.emit({ field: this.field, values: [...this.values, trimmedValue] });
    this.innerForm.get(this.innerInputName)?.setValue('', { emitEvent: false });
  }

  public removeChip(value: string): void {
    const index: number = this.values.indexOf(value);
    if (index >= 0) {
      const newValues = [...this.values];
      newValues.splice(index, 1);

      this.isInternalChipUpdate = true;
      this.valueChange.emit({ field: this.field, values: newValues });
    }
  }
}
